import React, { useState } from "react";
import {
  Center,
  Card,
  Grid,
  Group,
  Image,
  Loader,
  Text,
  Pagination,
} from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { Link, useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import dayjs from "dayjs";

import { MANY_NEWS } from "../../gqls/news";

const TAKE = 24;

export const NewsPage = () => {
  const [skip, setSkip] = useState(0);

  const navigate = useNavigate();

  const { data, loading } = useQuery(MANY_NEWS, {
    fetchPolicy: "network-only",
    variables: { skip, take: TAKE },
  });

  const news = data?.manyNews || [];
  const totalCount = data?.manyNewsCount || 0;

  const pagesCount = Math.ceil(totalCount / TAKE);
  const currentPage = skip / TAKE + 1;

  return (
    <>
      <Group align="center" justify="space-between">
        <Text fw="600">Новости</Text>
        <Link to="/news/create">
          <Group gap={6} align="center">
            <IconPlus color="#228be6" size={16} />
            <Text size="sm" c="blue">
              Добавить
            </Text>
          </Group>
        </Link>
      </Group>
      {loading ? (
        <Center h={100}>
          <Loader size="sm" />
        </Center>
      ) : (
        <>
          <Grid mt={16}>
            {news.map((item) => (
              <Grid.Col span={3} key={item.id}>
                <Card
                  withBorder
                  padding="xs"
                  onClick={() => navigate(`/news/${item.id}`)}
                  style={{ cursor: "pointer" }}
                >
                  <Card.Section>
                    <Image src={`/uploads/${item.image}`} alt={item.image} />
                  </Card.Section>
                  <Text size="xs" truncate="end" mt={8}>
                    {item.title}
                  </Text>
                  <Text c="gray" size="xs">
                    {dayjs(item.createdAt).format("DD.MM.YYYY HH:mm")}
                  </Text>
                </Card>
              </Grid.Col>
            ))}
          </Grid>
          <Pagination
            onChange={(v) => setSkip((v - 1) * TAKE)}
            value={currentPage}
            size="sm"
            mt={16}
            total={pagesCount}
          />
        </>
      )}
    </>
  );
};
